import {useQuery} from "@tanstack/react-query";
import {getMyProfileGamerService} from "../services/gamification.service";

export const useGetMyProfileGamer = () => {
  const {data, isSuccess, refetch, isLoading} = useQuery({
    queryKey: ["getMyProfileGamerService"],
    queryFn: getMyProfileGamerService,
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos en cache (opcional)
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return {
    isLoading,
    isSuccess,
    refetch,
    data: data?.data?.data,
  };
};
